import classnames from "classnames";
import React, { FC, memo } from "react";

import { IStyleColor, IStyleSize } from "../../../../../Style";

type TColor = "primary";
type Style = IStyleSize & IStyleColor<TColor>;

export interface ILoader extends Partial<Style> {
  className?: string;
  text?: string;
}

export const Loader: FC<ILoader> = memo(({ className, size = "md", color = "primary", text }) => {
  const classNames = classnames(
    "el-loader",
    {
      [`el-loader--size-${size}`]: !!size,
      [`el-loader--color-${color}`]: !!color,
    },
    className,
  );

  return (
    <span className={classNames}>
      <span className="el-loader__spinner" />
      {text && <span className="el-loader__text">{text}</span>}
    </span>
  );
});
